import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import router from "./router";
import Axios from "axios";
import store from "./store";
import { i18n } from "@/plugins/i18n";
import { Trans } from "./plugins/Translation";
import Router from "vue-router";
import VueCountryCode from "vue-country-code";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import VueHtmlToPaper from "vue-html-to-paper";
import DatetimePicker from "vuetify-datetime-picker";
import Lightbox from "vue-easy-lightbox";
import Permissions from "@/plugins/permissions";
import timeTransform from "@/plugins/timeTransform";
import { refreshToken } from "./utils/refreshToken";
// import VuetifulBoard from 'vuetiful-board'

//new imports for redirect-flow
import config from "./config";
import { PublicClientApplication } from "@azure/msal-browser";
import { resetMsalInteractionState, setMsAuthError } from "@/utils/msAuth";

const qs = require("querystring");

// Vue.use(VuetifulBoard)

const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900",
    "https://cdn.jsdelivr.net/npm/@mdi/font@4.x/css/materialdesignicons.min.css",
    "https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css",
  ],
};

Vue.component(VueQrcode.name, VueQrcode);

Vue.config.productionTip = false;
//Vue.prototype.$msalInstance = {};
let runtimeConfig = config.msalConfig;
const saved = sessionStorage.getItem("msal_runtime_config");
if (saved) {
  try {
    runtimeConfig = JSON.parse(saved);
  } catch (e) {
    runtimeConfig = config.msalConfig; // fallback на дефолт
  }
}
const msalInstance = new PublicClientApplication(runtimeConfig);
Vue.prototype.$msalInstance = msalInstance;

Vue.prototype.$http = Axios;
Vue.prototype.$i18nRoute = Trans.i18nRoute.bind(Trans);
Vue.use(VueCountryCode);
Vue.use(VueHtmlToPaper, options);
Vue.use(DatetimePicker);
Vue.use(Lightbox);
Vue.use(Permissions);
Vue.use(timeTransform);

const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};

Vue.directive("scroll", {
  inserted: function(el, binding) {
    let f = function(evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener("scroll", f);
      }
    };
    window.addEventListener("scroll", f);
  },
});

async function initApp() {
  let redirectResult = null;
  let cameFromMsRedirect = false;

  try {
    redirectResult = await msalInstance.handleRedirectPromise();
    if (redirectResult) cameFromMsRedirect = true;
  } catch (e) {
    cameFromMsRedirect = true;
    sessionStorage.removeItem("msal.interaction.status");
    sessionStorage.removeItem("ms_login_in_progress");
    setMsAuthError(e?.message || String(e));
  }

  // Флаг: надо ли после mount сделать переход
  let postLoginRoute = null;

  if (redirectResult && redirectResult.account) {
    cameFromMsRedirect = true;

    try {
      msalInstance.setActiveAccount(redirectResult.account);

      const tokenResponse = await msalInstance.acquireTokenSilent({
        scopes: ["User.Read"],
        account: redirectResult.account,
      });

      const response = await Axios.post(
        config.apiBaseUrl + "microsoft/token",
        qs.stringify({ access_token: tokenResponse.accessToken, state: true })
      );

      if (response.status === 200) {
        const u = response.data;

        //КРИТИЧНО: записываем ВСЁ (как было у тебя в рабочем popup)
        localStorage.setItem("userName", u.username);
        localStorage.setItem("accessToken", u.access_token);
        localStorage.setItem("role", u.role);
        localStorage.setItem("userId", u.userId);
        localStorage.setItem("guid", u.guid);
        localStorage.setItem("organization", u.organization);
        localStorage.setItem("organizationId", u.organizationId);
        localStorage.setItem("permissions", u.permissions);

        const lang = (u.language || "en").toLowerCase();
        localStorage.setItem("lang", lang);

        i18n.locale = lang;
        Trans.changeLanguage(lang);

        localStorage.setItem(
          "showNewDashboardSign",
          u.showNewDashboardSign === "True" ? "true" : "false"
        );

        localStorage.setItem("loginMS", "true");
        store.commit("SET_LOGIN_USER", u);

        // после mount перейдём на orders
        postLoginRoute = `/${i18n.locale}/orders`;
      } else if (response.status === 202) {
        store.commit("SET_USER_ORGANIZATIONS", response.data);
        localStorage.setItem("loginMS", "true");
        localStorage.setItem("accessToken", response.data.access_token);

        /* eslint-disable */
        console.log("array : ", response.data);

        postLoginRoute = `/${i18n.locale}/select-store`;
      } else {
        setMsAuthError(`microsoft/token failed: HTTP ${response.status}`);
      }
    } catch (e) {
      const msg =
        e?.response?.data?.message ||
        e?.response?.data ||
        e?.message ||
        "Microsoft token exchange failed";
      setMsAuthError(String(msg));

      sessionStorage.removeItem("msal.interaction.status");
      sessionStorage.removeItem("ms_login_in_progress");
      sessionStorage.removeItem("start_msal_login");
    }
  }

  // 1) Монтируем приложение
  new Vue({ vuetify, router, store, i18n, render: (h) => h(App) }).$mount(
    "#app"
  );

  // 2) Если надо — выполняем переход ПОСЛЕ mount (надёжнее для Vue2)
  if (postLoginRoute) {
    router.replace(postLoginRoute);
    return;
  }

  // 3) Старт интерактивного логина после reload (email-flow)
  if (sessionStorage.getItem("start_msal_login") === "1") {
    sessionStorage.removeItem("start_msal_login");
    sessionStorage.removeItem("msal.interaction.status");
    sessionStorage.setItem("ms_login_in_progress", "1");

    const loginHint = sessionStorage.getItem("msal_login_hint") || undefined;

    resetMsalInteractionState();

    return msalInstance.loginRedirect({
      scopes: ["User.Read"],
      prompt: "select_account",
      loginHint,
    });
  }

  // 4) refreshToken НИКОГДА не в MSAL/AAD контексте
  if (!cameFromMsRedirect && localStorage.getItem("loginMS") !== "true") {
    await refreshToken();
  }
}

initApp();
